import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import auth from '../utils/auth';

const IndexVideoView = () =>
    import ('../views/IndexVideoView/IndexVideoView.vue');
const RecommendView = () =>
    import ('../views/recommendView/recommendView');
const LiveVideoView = () =>
    import ('../views/LiveVideoView/LiveVideoView');
const VideoDetailView = () =>
    import ('../views/VideoDetailView/VideoDetailView.vue');
const shareVideoDetail = () =>
    import ('../views/VideoDetailView/shareVideoDetail.vue');
const SearchView = () =>
    import ('../views/SearchView/SearchView.vue');
const LiveDetailView = () =>
    import ('../views/LiveDetailView/LiveDetailView.vue');
const PersonalCenterView = () =>
    import ('../views/PersonalCenterView/PersonalCenterView.vue');

Vue.use(VueRouter);

const routes = [

    {
        path: '*',
        redirect: '/indexvideo',
    },
    {
        path: '/',
        name: 'IndexVideo',
        component: IndexVideoView,
    },
    {
        path: '/videoDetail/:mediaId',
        name: 'VideoDetailView',
        component: VideoDetailView,
    },
    {
        path: '/shareVideoDetail/:mediaId',
        name: 'shareVideoDetail',
        component: shareVideoDetail,
    },
    {
        path: '/recommend',
        name: 'RecommendView',
        component: RecommendView,
    },
    {
        path: '/LiveVideo',
        name: 'LiveVideoView',
        component: LiveVideoView,
    },
    {
        path: '/LiveDetail/:params',
        name: 'LiveDetailView',
        component: LiveDetailView,
    },
    {
        path: '/PersonalCenter',
        name: 'PersonalCenterView',
        component: PersonalCenterView,
    },
    {
        path: '/Search/:keywords',
        name: 'SearchView',
        component: SearchView,
    },
];

const router = new VueRouter({
    mode: 'history',
    // base: process.env.BASE_URL,
    routes,
});


router.beforeEach((to, from, next) => {
    store.dispatch('startLoading');
    // 未登录则跳转到登录页面
    console.log(to.name)
    if (to.fullPath.includes("pages/videoDetail/shareVideoDetail")) {
        let id = to.fullPath.split("=")[1]
        let params = { "mediaId": id }

        return next({
            name: 'shareVideoDetail',
            params: params,
            replace: true,
        });
    }


    if (['IndexVideo'].includes(to.name) || ['shareVideoDetail'].includes(to.name)) {
        return next();
    }
    if (!['IndexVideo'].includes(to.name) && !auth.checkToken() && !['shareVideoDetail'].includes(to.name)) {
        // throw new Error('请先登录');
        return next({
            name: 'IndexVideo',
            replace: true,
        });
    }

    return next();
});
router.afterEach(() => {
    window.scrollTo(0, 0);
    store.dispatch('stopLoading');
});


// const routerPush = router.push;
// router.push = function push(location) {
//     return routerPush.call(this, location).catch(error => error);
// };
const originalPush = router.push;

router.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
export default router;